import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '#/components/ui/dialog';
import { useCallback, useMemo } from 'react';
import { ActionButton } from './button';
import { DialogContext, useDialogStore } from './dialog-store';
import { ButtonProps, DialogFlag, DialogProps } from './helpers';

export function DialogImpl({
  id,
  title,
  description,
  children,
  flags = DialogFlag.OK,
  yesLabel = 'Yes',
  noLabel = 'No',
  okLabel = 'OK',
  cancelLabel = 'Cancel',
  yesProps,
  noProps,
  okProps,
  cancelProps,
  // onRequestClose,
  // resolver,
  dismissedResolver,
  loadingFlag,
  elementRef,
  forwardedRef,
}: DialogProps) {
  const { requestClose, close } = useDialogStore();

  // const closable = useMemo(
  //   () =>
  //     Array.isArray(flags)
  //       ? flags.includes(DialogFlag.CLOSE)
  //       : Boolean(flags & DialogFlag.CLOSE),
  //   [flags]
  // );

  const buttons = useMemo(() => {
    const buttonPropsMap = new Map<DialogFlag, Omit<ButtonProps, 'onClick'>>([
      [DialogFlag.YES, Object.assign({ children: yesLabel }, yesProps)],
      [DialogFlag.NO, Object.assign({ children: noLabel }, noProps)],
      [
        DialogFlag.OK,
        Object.assign({ children: okLabel, type: 'primary' }, okProps),
      ],
      [
        DialogFlag.CANCEL,
        Object.assign({ children: cancelLabel }, cancelProps),
      ],
    ]);
    console.log('buttonPropsMap', buttonPropsMap);
    // 按钮排序
    const orderedFlags = Array.isArray(flags)
      ? flags
      : [
          DialogFlag.CANCEL,
          DialogFlag.OK,
          DialogFlag.NO,
          DialogFlag.YES,
        ].filter(flag => flags & flag);
    const orderedElements = orderedFlags.map(flag => {
      const buttonProps = buttonPropsMap.get(flag);
      return (
        <ActionButton
          key={flag}
          {...buttonProps}
          flag={flag}
          onClick={() => requestClose(id, flag)}
          loading={Boolean(loadingFlag & flag)}
        />
      );
    });
    return orderedElements;
  }, [
    okLabel,
    okProps,
    cancelLabel,
    cancelProps,
    yesLabel,
    yesProps,
    noLabel,
    noProps,
    loadingFlag,
    flags,
    requestClose,
  ]);

  const context = useMemo(
    () => ({
      requestClose: (flag: DialogFlag) => requestClose(id, flag),
      close: (flag: DialogFlag, returnValue?: unknown) =>
        close(id, flag, returnValue),
      forwardedRef,
    }),
    [id, requestClose, close, forwardedRef]
  );

  const onOpenChange = useCallback(
    (open: boolean) => {
      !open && requestClose(id, DialogFlag.CLOSE);
    },
    [requestClose, id]
  );

  const onCloseAutoFocus = useCallback(() => {
    dismissedResolver?.resolve();
  }, [dismissedResolver]);

  return (
    <DialogContext.Provider value={context}>
      <Dialog open={dismissedResolver == null} onOpenChange={onOpenChange}>
        <DialogContent ref={elementRef} onCloseAutoFocus={onCloseAutoFocus}>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
          {children}
          {buttons.length > 0 && <DialogFooter>{buttons}</DialogFooter>}
        </DialogContent>
      </Dialog>
    </DialogContext.Provider>
  );
}
